import { render, staticRenderFns } from "./SignInScreen.vue?vue&type=template&id=98ec774e&"
import script from "./SignInScreen.vue?vue&type=script&lang=js&"
export * from "./SignInScreen.vue?vue&type=script&lang=js&"
import style0 from "./SignInScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports